import React from 'react'
import { Collapse } from 'antd'
import FileUploaderControl from './components/file-uploader-control'
import TextBlocksControl from './components/text-blocks-control'
import ImportDataControl from './components/import-data-control'
import ExportControl from './components/export-control'
import TourButton from "../tour/tour-button"

const sectionsKeys = ["fileUploader", "textBlocks", "importData", "export"]
const defaultActiveSections = [sectionsKeys[0], sectionsKeys[1], sectionsKeys[2], sectionsKeys[3]]

const sections = [
    {
        key: sectionsKeys[0],
        label: "Фон",
        children: <FileUploaderControl />,
    },
    {
        key: sectionsKeys[1],
        label: "Текстовые блоки",
        children: <TextBlocksControl />,
    },
    {
        key: sectionsKeys[2],
        label: "Импорт данных",
        children: <ImportDataControl />,
    },
    {
        key: sectionsKeys[3],
        label: "Экспорт",
        children: <ExportControl />,
    },
]

const ControlsSectionWidget = () => {
    return (
        <aside className="ControlsSectionWidget">
            <div className="ControlsSectionWidget-body">
                <Collapse items={sections} defaultActiveKey={defaultActiveSections} />
            </div>
            <TourButton />
        </aside>
    )
}

export default ControlsSectionWidget